import { render, staticRenderFns } from "./PerformanceTargetTrafficLight.vue?vue&type=template&id=991d678c"
import script from "./PerformanceTargetTrafficLight.vue?vue&type=script&lang=js"
export * from "./PerformanceTargetTrafficLight.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports